import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlLookAt extends BaseControl {
    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: "fal fa-camera-movie",
                position: ControlPosition.RIGHT,
                tooltip: Language.resolve("Initiale Kameraposition festlegen", "Set initial camera position"),
                visible: false,
                onInit: (item) => {
                    this.pano.onChangeVideo.add((d) => {
                        item.visible = d && d.look_at;
                    });
                },
                onClick: (item) => {
                    var bounds = this.pano.viewContainer.getBoundingClientRect();
                    var clientX = bounds.left + bounds.width * 0.5;
                    var clientY = bounds.top + bounds.height * 0.5;
                    var pos = this.pano.view.toPosition(clientX, clientY);
                    this.pano.current.camera_x = pos.x;
                    this.pano.current.camera_y = pos.y;
                    this.pano.acfBridge.setCameraLookAt(pos.x, pos.y);
                }
            }
        );
    }
}